import React from 'react';
const FORM_URL = 'https://link.apisystem.tech/widget/form/8oL7mzyZiV6bC0aIfg98';
export function LegalFooter() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-dark border-t border-brand-border pt-16 pb-8" data-id="element-96">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-20" data-id="element-97">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-98">
          {/* CONTACT */}
          <div data-id="element-99">
            <h4 className="font-heading font-bold text-sm text-brand-accent uppercase tracking-industrial-wide mb-6" data-id="element-100">
              Contact
            </h4>
            <div className="space-y-4 font-body text-brand-muted text-sm leading-relaxed" data-id="element-101">
              <p data-id="element-102">DIA MANAGEMENT SOLUTIONS SRL CUI: 40869119</p>
              <p data-id="element-103">
                Adresa: Loc. Popești-Leordeni, Drum Fermei 67B, Bl. 10, Et. 5,
                Ap. 32
              </p>
              <p data-id="element-104">
                Telefon:{' '}
                <a href="tel:+40771574218" className="hover:text-brand-accent transition-colors" data-id="element-105">
                  +40 771 574 218
                </a>
              </p>
              <p data-id="element-106">
                email:{' '}
                <a href="mailto:contact@ionutdraganescu.com" className="hover:text-brand-accent transition-colors" data-id="element-107">
                  contact@ionutdraganescu.com
                </a>
              </p>
            </div>
          </div>

          {/* LEGAL */}
          <div data-id="element-108">
            <h4 className="font-heading font-bold text-sm text-brand-accent uppercase tracking-industrial-wide mb-6" data-id="element-109">
              Legal
            </h4>
            <ul className="space-y-4 font-body text-brand-muted text-sm uppercase tracking-wide" data-id="element-110">
              <li data-id="element-111">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-112">
                  Termeni și condiții
                </a>
              </li>
              <li data-id="element-113">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-114">
                  Politica de confidențialitate
                </a>
              </li>
              <li data-id="element-115">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-116">
                  Politica de cookies
                </a>
              </li>
              <li data-id="element-117">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-118">
                  ANPC
                </a>
              </li>
            </ul>
          </div>

          {/* SOCIAL MEDIA — text only, no icons for now */}
          <div data-id="element-119">
            <h4 className="font-heading font-bold text-sm text-brand-accent uppercase tracking-industrial-wide mb-6" data-id="element-120">
              Social Media
            </h4>
            <ul className="space-y-4 font-body text-brand-muted text-sm" data-id="element-121">
              <li data-id="element-122">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-123">
                  WhatsApp
                </a>
              </li>
              <li data-id="element-124">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-125">
                  Youtube
                </a>
              </li>
              <li data-id="element-126">
                <a href="https://www.facebook.com/p/Ionut-Draganescu-Business-Coach-61559171806988/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent transition-colors" data-id="element-127">
                  Facebook
                </a>
              </li>
              <li data-id="element-128">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-129">
                  Instagram
                </a>
              </li>
              <li data-id="element-130">
                <a href="#" className="hover:text-brand-accent transition-colors" data-id="element-131">
                  Tiktok
                </a>
              </li>
            </ul>
          </div>

          {/* ANPC badges */}
          <div className="flex flex-col gap-3" data-id="element-132">
            <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" className="block bg-white rounded overflow-hidden max-w-[240px]" data-id="element-133">
              <img src="https://cdn.magicpatterns.com/uploads/kH89FHQ1Bu3YUHdZrqj266/GDPR_1.webp" alt="ANPC — Soluționarea Alternativă a Litigiilor" className="w-full h-auto" data-id="element-134" />
            </a>
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="block bg-white rounded overflow-hidden max-w-[240px]" data-id="element-135">
              <img src="https://cdn.magicpatterns.com/uploads/pEsoYEM8BXkbw3Kuz8L6Ay/GDPR_2.jpg" alt="Soluționarea Online a Litigiilor" className="w-full h-auto" data-id="element-136" />
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-brand-border mb-8" data-id="element-137" />

        {/* Copyright */}
        <p className="text-center font-body text-brand-dim text-sm" data-id="element-138">
          &copy; Copyright {currentYear}.{' '}
          <span className="text-brand-muted font-semibold" data-id="element-139">
            DIA MANAGEMENT SOLUTIONS SRL
          </span>
          . Toate drepturile rezervate.
        </p>
      </div>
    </footer>;
}